import { render, staticRenderFns } from "./jiebanglist.vue?vue&type=template&id=533a7c99&scoped=true&"
import script from "./jiebanglist.vue?vue&type=script&lang=js&"
export * from "./jiebanglist.vue?vue&type=script&lang=js&"
import style0 from "./jiebanglist.vue?vue&type=style&index=0&id=533a7c99&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533a7c99",
  null
  
)

export default component.exports